import type { VoiceItemProps } from "../../../../../utils/types";
import style from "./NewVoice.module.scss";
import { useMediaPreview } from "../../../../PreviewAvatarMedia/MediaPreviewProvider";

const VoiceItem = ({
	value,
	preview_url,
	onClick,
	active,
	useCase,
	temper,
	index,
  }: VoiceItemProps) => {
	const { videoRef, videoState, currentVoiceId, play, pause } = useMediaPreview();
	const isCurrent = currentVoiceId === value;

	const playAudio = (e: React.MouseEvent<HTMLDivElement>) => {
		e.preventDefault();
		if (isCurrent) {
			e.stopPropagation();
		}

		if (!videoRef.current) return;
		videoState === 'playing' ? pause() : play();
	};

	return (
	  <div
		onClick={() => onClick(value)}
		className={`${style.voiceItemContainer} ${active && style.active}`}
	  >
		<div
		  onClick={(e) => playAudio(e)}
		  className={`${style.playButton} ${videoState === 'playing' && isCurrent ? style.pause : ''}`}
		></div>
		<div className={style.voiceDescription}>
		  <span className={`${style.useCase} ${active && style.selected}`}>
			{`Голос ${index}`}
		  </span>
		  <span className={style.temper}>{useCase}</span>
		</div>
	  </div>
	);
  };
  
  export default VoiceItem;
